import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=0af5f6f2&scoped=true&"
import script from "./Jobs.vue?vue&type=script&lang=ts&"
export * from "./Jobs.vue?vue&type=script&lang=ts&"
import style0 from "./Jobs.vue?vue&type=style&index=0&id=0af5f6f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5f6f2",
  null
  
)

export default component.exports